export default {
  title: 'Тарифы',

  tariff: 'Тариф',
  tariffs: 'Тарифы',
  new: 'Новый тариф',
  create: 'Создать новый тариф',
  activeAt: 'Активен с',
  cycle: 'Цикл',
  per: 'через',
  for: 'для',
  inherited: 'Наследовано из тарифа',
  withOperatorGroups: '(с группой оператора)',
  sendingId: 'ID отправления',
  conditions: 'Условия',
  customize: 'Изменить',
  unconditional: 'Безусловное правило',
  usersOnTariff: 'Пользователи на тарифе',
  addRule: 'Добавить правило',
  addSetConditions: 'Добавить группу условий',
  addAnotherSetConditions: 'Добавить ещё одну группу условий',
  always: 'Всегда',
  otherCases: 'В остальных случаях',
  choosePath: '<Выберите, что проверять>',
  chooseCondition: '<Укажите, как проверять>',
  matchesWith: 'Совпадает с',
  matchesWithRegex: 'регулярным выражением',
  matchesWithMultiple: 'одним из значений',
  operator: 'ни одного оператора | один оператор | {count} оператора(ов)',
  sender: 'ни одного имени отправителя | одно имя отправителя | {count} имени отправителя',
  rule: 'Правило #{rule}',

  titles: {
    rules: 'Правила',
    similar: 'Найден похожий тариф',
    packets: 'Пакеты сообщений',
    priceRanges: 'Ценовые сегменты',

    confirm: {
      clone: 'Подтвердите клонирование'
    }
  },

  contents: {
    similar: 'Тариф с таким названием уже существует. Если вы всё равно хотите создать дубль тарифа, то нажмите "Создать". В противном случае нажмите "Закрыть".',

    confirm: {
      clone: {
        simple: 'Вы уверены, что хотите клонировать тариф?',
        divided: 'Вы уверены, что хотите клонировать тариф, разделив цены на 100?'
      }
    }
  },

  cycles: {
    month: 'Месяц',
    week: 'Неделя',
    day: 'День',
    trigger: 'Trigger'
  },

  labels: {
    tariff: 'Тариф',
    title: 'Заголовок',
    source: 'Источник',
    cycle: 'Цикл',
    cycleStart: 'Начало цикла',
    price: 'Цена',
    comment: 'Комментарий',
    owner: 'Владелец',
    actions: 'Действие',
    refundOnFailed: 'Возместить при неудаче',
    noPayments: 'Может быть бесплатным',
    rules: 'Правила',
    index: 'Тариф #{index}',
    priceRangesCustomKey: 'Произвольный ключ для ценовых сегментов',
    priceRangesUseSendernameInKey: 'Добавлять имя отправителя в ключ счетчика',

    activePeriod: {
      start: 'Стартовая дата',
      end: 'Конечная дата'
    },

    conditions: {
      path: 'Путь',
      comparator: 'Сравнение',
      value: 'Значение',
      negate: 'Отрицание',
      multiple: 'Выберите из списка',
      regex: 'Впишите регулярное выражение'
    },

    priceRanges: {
      key: 'Ключ',
      price: 'Цена сегмента'
    },

    packets: {
      size: 'Размер пакета',
      price: 'Цена пакета',
      priority: 'Приоритет'
    }
  },

  tabs: {
    eventsHistory: 'История изменений'
  },

  dialogs: {
    new: 'Новый тариф'
  },

  subheaders: {
    rules: 'Правила',
    conditions: 'Условия',
    activePeriod: {
      title: 'Активный период',
      start: 'Начало активного периода',
      end: 'Конец активного периода'
    },
    cycleStart: 'Начало цикла'
  },

  actions: {
    decrease: 'Списать',
    increase: 'Начислить',
    main: {
      decrease: 'Списывать',
      increase: 'Начислять'
    }
  },

  buttons: {
    add: {
      tariff: 'Добавить тариф',
      rule: 'Добавить правило',
      condition: 'Добавить условие'
    },
    remove: {
      tariff: 'Удалить тариф'
    },
    clone: {
      divided: '/ 100'
    }
  },

  tooltips: {
    custom: 'Кастомизированный',
    copyTitle: 'Скопировать заголовок',

    clone: {
      simple: 'Клонировать тариф',
      divided: 'Клонировать тариф с делением цен на 100'
    },

    empty: {
      condition: 'Условие заполнено не полностью'
    },

    remove: {
      default: {
        rule: {
          always: 'Удалить правило',
          otherCases: 'Удалить правило для остальных случаев'
        }
      }
    }
  },

  snackbars: {
    created: 'Тариф успешно создан.',
    updated: 'Тариф успешно обновлён.',
    removed: 'Тариф успешно удалён.'
  },

  hints: {
    default: 'За сообщение',
    perCall: 'За сегмент',
    perSecond: 'За секунду',
    perPeriod: 'За период',
    priceRangesCustomKey: 'Максимум 150 символов'
  }
}
